import React from 'react'
import { object } from 'prop-types'
import { PrismicRichText } from '@prismicio/react'
import { v4 as uuidv4 } from 'uuid'
import { Link } from 'gatsby'
import * as Styled from './styles/IconTextBlock.styles'
import CtaLink from './CtaLink'
import { linkResolver } from './../../util/linkResolver'

const ExternalLink = ({ link, text }) => (
  <a href={link} target="_blank" rel="noreferrer">
    {text}
  </a>
)

const InternalLink = ({ link, text }) => (
  <Link to={linkResolver(link)}>{text}</Link>
)

const ItemTextLink = ({ text, link }) => {
  if (!link || !link.link_type) {
    return null
  }

  if (link.link_type === 'Document') {
    if (!link.uid) {
      return null
    } // only link to valid page types

    return <InternalLink link={link} text={text} />
  }

  if (link.link_type === 'Web' || link.link_type === 'File') {
    return <ExternalLink link={link.url} text={text} />
  }

  return null
}

const Item = ({ item }) => (
  <Styled.Item>
    <Styled.ItemIconContainer>
      {item.item_icon?.url && (
        <Styled.ItemIcon src={item.item_icon.url} alt={item.item_icon.alt} />
      )}
    </Styled.ItemIconContainer>
    {/* <pre>{JSON.stringify(item)}</pre> */}
    <Styled.ItemTextContainer>
      {item.item_title && (
        <>
          <PrismicRichText field={item.item_title.richText} />
        </>
      )}
      {item.item_body_text && (
        <>
          <PrismicRichText field={item.item_body_text.richText} />
        </>
      )}
      {item.cta_text && item.cta_link && (
        <div>
          <CtaLink text={item.cta_text} link={item.cta_link} />
        </div>
      )}
    </Styled.ItemTextContainer>
  </Styled.Item>
)

const IconTextBlock = ({ data, bottomPaddingAdjustment }) => (
  <Styled.IconTextBlock bottomPaddingAdjustment={bottomPaddingAdjustment}>
    <Styled.TextContainer>
      <Styled.Title>
        <PrismicRichText field={data.primary.header.richText} />
      </Styled.Title>
      <Styled.Body>
        <PrismicRichText field={data.primary.body_text.richText} />
      </Styled.Body>
    </Styled.TextContainer>
    <Styled.Items>
      {data.items.map(item => (
        // <pre>{JSON.stringify(item)}</pre>
        <Item key={uuidv4()} item={item} />
      ))}
    </Styled.Items>
  </Styled.IconTextBlock>
)

IconTextBlock.propTypes = {
  data: object,
}

export default IconTextBlock
